<template>
  <el-dropdown>
    <span class="el-dropdown-link">
      {{ t("m.language") }}
      <i
        class="iconfont icon-xiala"
        style="font-size: 10px; margin-left: 5px"
      ></i>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item @click="changeLanguage('zh-CN')">
          中文
        </el-dropdown-item>
        <el-dropdown-item @click="changeLanguage('en-US')">
          English
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();

const changeLanguage = (language: string) => {
  // locale.value = language;
  locale.value = language;
};
</script>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
  font-size: 16px;
}
</style>
